import { Redirect, Route, Switch } from "react-router-dom";

import BotpressClientPortal from "./components/portals/botpressClientPortal";
import BotpressInvitePortal from "./components/portals/botpressInvitePortal";
import BotpressTestHarnessPortal from "./components/portals/botpressTestHarnessPortal";
import CreatorPortal from "./components/portals/creatorPortal";

import constants from "./assets/constants";

const getBotpressOrganizationPortal = awsGroup => {
  if (awsGroup === constants.userGroups.Administrator) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathAdmin}>
          <BotpressClientPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminInvite}>
          <BotpressInvitePortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminBotpressTestHarness}>
          <BotpressTestHarnessPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathAdmin} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Provider) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathProvider}>
          <BotpressClientPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathProviderInvite}>
          <BotpressInvitePortal />
        </Route>
        <Route exact path={constants.appPaths.appPathProviderBotpressTestHarness}>
          <BotpressTestHarnessPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathProvider} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Partner) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathPartner}>
          <BotpressClientPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathPartnerBotpressTestHarness}>
          <BotpressTestHarnessPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathPartner} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Patient) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathPatient}>
          <BotpressClientPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminHarness}>
          <BotpressTestHarnessPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathPatient} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Creator) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathCreator}>
          <CreatorPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathCreator} />} />
      </Switch>
    );
  }
};

export default getBotpressOrganizationPortal;
